import { auth, getToken } from '@/assets/utils'
import { defineStore } from 'pinia'
import { ref } from 'vue'


export const useAuthStore = defineStore('auth', () => {
    const isAuthenticated = ref(false)

    async function login(key: string) {

        const res = await auth.get(
            `${import.meta.env.VITE_API_ENDPOINT}/auth`,
            key
        )

        if (res.status != 200) {
            isAuthenticated.value = false
        } else {
            localStorage.setItem("admin-auth", key)
            isAuthenticated.value = true
        }

        return isAuthenticated.value
    }

    async function logout() {
        isAuthenticated.value = false
        localStorage.removeItem('admin-auth')
    }

    async function checkAuth() {

        const token = getToken()
        if (!token) {
            return
        }

        const res = await auth.get(
            `${import.meta.env.VITE_API_ENDPOINT}/auth`,
            token
        ).catch((data) => data)

        if (res.status != 200) {
            isAuthenticated.value = false
            localStorage.removeItem("admin-auth")
        } else {
            isAuthenticated.value = true
        }
    }

    return { isAuthenticated, login, logout, checkAuth }
})
